export const calculatePerpetualFlatDiscount = ({
  flatItemDiscount,
  totalValue,
  orderItems,
}: {
  flatItemDiscount: number;
  totalValue: number;
  orderItems: { quantity: number }[];
}) => {
  const applicableItemQuantity = orderItems.reduce(
    (prev, orderItem) => prev + orderItem.quantity,
    0,
  );

  const discountTotal = applicableItemQuantity * flatItemDiscount;
  return discountTotal > totalValue ? totalValue : discountTotal;
};
